import HackTheBox from "../../assets/htb-logo.png"
import TIWAP from "../../assets/blogs/TIWAP.png";
import Wreath from "../../assets/blogs/Wreath.png";
import AD from "../../assets/blogs/active-directory.jpeg";


const blog_data = [
    {
        "title": "TIWAP Official Walkthrough | Hard Difficulty",
        "banner": TIWAP,
        "summary": "This is the official walkthrough of Totally Insecure Web Application Project (TIWAP) with " +
            "hard level of difficulty.",
        "url": "/blogs/tiwapHard-official-walkthrough",
        "filename": "TIWAP_Hard.md",
        "retired": true,
        "date": "03-03-2022",
        "tags": ["Web", "Multiple Vulnerabilities"]
    },
    {
        "title": "TIWAP Official Walkthrough | Medium Difficulty",
        "banner": TIWAP,
        "summary": "This is the official walkthrough of Totally Insecure Web Application Project (TIWAP) with " +
            "medium level of difficulty.",
        "url": "/blogs/tiwapMedium-official-walkthrough",
        "filename": "TIWAP_Medium.md",
        "retired": true,
        "date": "28-02-2022",
        "tags": ["Web", "Multiple Vulnerabilities"]
    },
    {
        "title": "Driver Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Windows Machine vulnerable to PrintNightmare CVE-2021-34527",
        "url": "/blogs/driver-walkthrough-htb",
        "filename": "Driver_HTB.md",
        "retired": false,
        "date": "15-10-2021",
        "tags": ["Default Credentials", "File Upload", "CVE"]
    },
    {
        "title": "TIWAP Official Walkthrough | Low Difficulty",
        "banner": TIWAP,
        "summary": "This is the official walkthrough of Totally Insecure Web Application Project (TIWAP) with " +
            "low level of difficulty.",
        "url": "/blogs/tiwapLow-official-walkthrough",
        "filename": "TIWAP_Easy.md",
        "retired": true,
        "date": "14-02-2022",
        "tags": ["Web", "Multiple Vulnerabilities"]
    },
    /*{
        "title": "Pandora Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "An Easy Linux Machine vulnerable to CVE-2021-32099",
        "url": "/blogs/pandora-walkthrough-htb",
        "filename": "Pandora_HTB.md",
        "retired": false,
        "date": "10-01-2022",
        "tags": []
    },*/
    {
        "title": "Sauna Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Windows Box running a AD Server vulnerable to Kerberoasting and DC Sync attack.",
        "url": "/blogs/sauna-walkthrough-htb",
        "filename": "Sauna_HTB.md",
        "retired": true,
        "date": "12-01-2022",
        "tags": ["AD", "Kerberoasting", "Powershell"]
    },
    {
        "title": "Enterprise Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Machine running multiple CMS in a docker environment and requires static " +
            "analysis for privilege escalation",
        "url": "/blogs/enterprise-walkthrough-htb",
        "filename": "Enterprise_HTB.md",
        "retired": true,
        "date": "10-01-2022",
        "tags": ["Web", "SQLi", "Docker"]
    },
    {
        "title": "Forge Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A medium level linux machine vulnerable to SSRF and teaches about python debugger",
        "url": "/blogs/forge-walkthrough-htb",
        "filename": "Forge_HTB.md",
        "retired": true,
        "date": "10-12-2021",
        "tags": ["Web", "SSRF", "Python"]
    },
    /*{
        "title": "Backdoor Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Web Server running vulnerable GDB Server and un-patched CVE-2021-3560",
        "url": "/blogs/backdoor-walkthrough-htb",
        "filename": "Backdoor_HTB.md",
        "retired": false,
        "date": "08-12-2021"
    },*/
    {
        "title": "Blunder Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "An Easy Linux Machine requiring good enumeration and running Bludit CMS vulnerable " +
            "to Arbitrary Upload",
        "url": "/blogs/blunder-walkthrough-htb",
        "filename": "Blunder_HTB.md",
        "retired": true,
        "date": "16-11-2021",
        "tags": ["CMS", "Enumeration"]
    },
    /*{
        "title": "Secret Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Machine that requires code reviews for user as well as root.",
        "url": "/blogs/secret-walkthrough-htb",
        "filename": "Secret_HTB.md",
        "retired": false,
        "date": "03-11-2021"
    },*/
    {
        "title": "TIWAP",
        "banner": TIWAP,
        "summary": "Due to vast evolvement of web technologies and design methodologies, the developers thought of " +
            "creating a web security lab which is highly vulnerable to most of the common attack methods. TIWAP is a " +
            "web application designed for beginners in web application security who want to learn and explore this " +
            "field, thus made for educational purposes only. It focuses on 20 vulnerabilities, each having 3 levels " +
            "of difficulty.",
        "url": "https://singh-simardeepsingh99.medium.com/tiwap-3a8b70043ce9",
        "filename": null,
        "retired": true,
        "date": "17-10-2021",
        "tags": ["Web", "Multiple Vulnerabilities"]
    },
    {
        "title": "Writer Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Web Server vulnerable to SQLi and RCE via File Upload. Requires Code Review and " +
            "some script writing for privilege escalation.",
        "url": "/blogs/writer-walkthrough-htb",
        "filename": "Writer_HTB.md",
        "retired": true,
        "date": "16-10-2021",
        "tags": ["Web", "SQLi", "File Upload", "RCE"]
    },
    {
        "title": "DevOops Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux machine running a Web Application vulnerable to XXE and requires git enumeration " +
            "for privilege escalation.",
        "url": "/blogs/devoops-walkthrough-htb",
        "filename": "DevOops_HTB.md",
        "retired": true,
        "date": "13-10-2021",
        "tags": ["Web", "XXE", "Git"]
    },
    {
        "title": "Buff Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "Windows Server running a Gym Management Application and requires BufferOverflow for " +
            "administrative access.",
        "url": "/blogs/buff-walkthrough-htb",
        "filename": "Buff_HTB.md",
        "retired": true,
        "date": "12-10-2021",
        "tags": ["Web", "Exploit-DB", "Buffer Overflow"]
    },
    {
        "title": "Seal Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux machine with Sensitive Data Exposure on GitBucket chained with LFI on Apache Tomcat.",
        "url": "/blogs/seal-walkthrough-htb",
        "filename": "Seal_HTB.md",
        "retired": true,
        "date": "02-10-2021",
        "tags": ["Web", "LFI", "Tomcat"]
    },
    {
        "title": "Intelligence Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "Windows Machine with Sensitive Data Exposure in File MetaData and requiring DNS Manipulation " +
            "chained with Silver Ticket Attack for administrator.",
        "url": "/blogs/intelligence-walkthrough-htb",
        "filename": "Intelligence_HTB.md",
        "retired": true,
        "date": "30-09-2021",
        "tags": ["AD", "DNS", "Scripting"]
    },
    {
        "title": "Dynstr Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Server running a DNS Management Application having an insecure API",
        "url": "/blogs/dynstr-walkthrough-htb",
        "filename": "Dynstr_HTB.md",
        "retired": true,
        "date": "28-09-2021",
        "tags": ["DNS", "Web", "RCE"]
    },
    {
        "title": "Explore Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "Android Machine vulnerable to CVE-2019-6447",
        "url": "/blogs/explore-walkthrough-htb",
        "filename": "Explore_HTB.md",
        "retired": true,
        "date": "26-09-2021",
        "tags": ["Android", "CVE", "Port Forwarding"]
    },
    {
        "title": "Horizontall Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Web Server running on Linux, exposing a production API vulnerable to CVE-2019-18818 " +
            "and an internal server vulnerable to CVE-2021-3219",
        "url": "/blogs/horizontall-walkthrough-htb",
        "filename": "Horizontall_HTB.md",
        "retired": true,
        "date": "23-09-2021",
        "tags": ["Web", "API", "CVE"]
    },
    {
        "title": "Previse Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "Linux based Web Server vulnerable to request manipulation for Login Bypass " +
            "and further having vulnerable parameter resulting into RCE.",
        "url": "/blogs/previse-walkthrough-htb",
        "filename": "Previse_HTB.md",
        "retired": true,
        "date": "18-09-2021",
        "tags": ["Web", "Auth Bypass", "RCE"]
    },
    {
        "title": "Bounty Hunter Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "An Easy Linux machine vulnerable to XXE and code review for Privilege Escalation.",
        "url": "/blogs/bountyHunter-walkthrough-htb",
        "filename": "BountyHunter_HTB.md",
        "retired": true,
        "date": "05-09-2021",
        "tags": ["Web", "XXE", "Python"]
    },
    {
        "title": "Cap Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Web Server running a Network Dashboard vulnerable to IDOR and SUID files for " +
            "Privilege Escalation.",
        "url": "/blogs/cap-walkthrough-htb",
        "filename": "Cap_HTB.md",
        "retired": true,
        "date": "19-07-2021",
        "tags": ["Web", "IDOR", "Wireshark", "Capabilities"]
    },
    {
        "title": "Knife Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A PHP Web Server having RCE in the Web Request and basic file analysis for " +
            "privilege escalation.",
        "url": "/blogs/knife-walkthrough-htb",
        "filename": "Knife_HTB.md",
        "retired": true,
        "date": "18-07-2021",
        "tags": ["Web", "PHP", "Ruby"]
    },
    {
        "title": "Traverxec Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Website running a vulnerable version of nostromo web server and containing " +
            "misconfigured files.",
        "url": "/blogs/traverxec-walkthrough-htb",
        "filename": "Traverxec_HTB.md",
        "retired": true,
        "date": "17-07-2021",
        "tags": ["Web", "Enumeration"]
    },
    {
        "title": "Active Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "An AD Server perfect for beginners in AD Exploitation.",
        "url": "/blogs/active-walkthrough-htb",
        "filename": "Active_HTB.md",
        "retired": true,
        "date": "16-07-2021",
        "tags": ["Windows", "AD", "Kerberoasting"]
    },
    {
        "title": "Bastion Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Windows Server containing a number of misconfigured files resulting in shell access " +
            "and privilege escalation.",
        "url": "/blogs/bastion-walkthrough-htb",
        "filename": "Bastion_HTB.md",
        "retired": true,
        "date": "15-07-2021",
        "tags": ["NFS", "Windows", "Enumeration"]
    },
    {
        "title": "Heist Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Windows Server having Leaked Credentials and requires process inspection " +
            "for privilege escalation.",
        "url": "/blogs/heist-walkthrough-htb",
        "filename": "Heist_HTB.md",
        "retired": true,
        "date": "14-07-2021",
        "tags": ["Sensitive Data Exposure", "Process Monitoring"]
    },
    {
        "title": "Shocker Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux machine vulnerable to CVE-2014-6271.",
        "url": "/blogs/shocker-walkthrough-htb",
        "filename": "Shocker_HTB.md",
        "retired": true,
        "date": "14-07-2021",
        "tags": ["CVE", "Perl"]
    },
    {
        "title": "WriteUp Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux server running CMS made Simple vulnerable to SQLi with CVE-2019-9053.",
        "url": "/blogs/writeup-walkthrough-htb",
        "filename": "WriteUp_HTB.md",
        "retired": true,
        "date": "14-07-2021",
        "tags": ["SQLi", "Exploit-DB", "CronJobs"]
    },
    {
        "title": "Forest Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "An AD Server with RPC Enumeration and vulnerable to AS-REP Roasting. Requires DCSync " +
            "Manipulation for Privilege Escalation.",
        "url": "/blogs/forest-walkthrough-htb",
        "filename": "Forest_HTB.md",
        "retired": true,
        "date": "10-07-2021",
        "tags": ["AD", "AS-REP", "RPC"]
    },
    {
        "title": "Wreath Walkthrough | TryHackMe",
        "banner": Wreath,
        "summary": "Wreath is a vulnerable network designed by MuirlandOracle as a learning resource which focuses " +
            "on: Pivoting, Working with Empire C2 and Simple Antivirus Evasion techniques",
        "url": "https://singh-simardeepsingh99.medium.com/wreath-walk-through-4e3c51905ebb",
        "filename": null,
        "retired": true,
        "date": "26-06-2021",
        "tags": ["Network", "C2", "AV Evasion", "Code Analysis", "Git"]
    },
    {
        "title": "Active Directory",
        "banner": AD,
        "summary": "Active Directory is a topic which most of the learners find difficult to understand and due to " +
            "its rise in the industry, aspiring Pen-Testers are keen to exploit practice labs. Therefore I decided " +
            "to write a blog post regarding it so that the learners could find it easy to understand.",
        "url": "https://singh-simardeepsingh99.medium.com/active-directory-2121ab3501d",
        "filename": null,
        "retired": true,
        "date": "14-06-2021",
        "tags": ["AD"]
    },
    {
        "title": "Love Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Windows Server exposing Staging Site which is vulnerable to SSRF and RCE via File Upload.",
        "url": "/blogs/love-walkthrough-htb",
        "filename": "Love_HTB.md",
        "retired": true,
        "date": "18-05-2021",
        "tags": ["Web", "SSRF", "File Upload"]
    },
    {
        "title": "Armageddon Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Server running Drupal CMS and vulnerable to Dirty Sock Exploit.",
        "url": "/blogs/armageddon-walkthroguh-htb",
        "filename": "Armageddon_HTB.md",
        "retired": true,
        "date": "17-05-2021",
        "tags": ["Web", "CMS", "Dirty Sock"]
    },
    {
        "title": "Spectra Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux based OS running an old version of WordPress and containing misconfigured files.",
        "url": "/blogs/spectra-walkthrough-htb",
        "filename": "Spectra_HTB.md",
        "retired": true,
        "date": "16-05-2021",
        "tags": ["Web", "CMS", "File Misconfigurations"]
    },
    {
        "title": "Script Kiddie Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux machine perfect for beginners into Exploitation.",
        "url": "/blogs/scriptKiddie-walkthrough-htb",
        "filename": "ScriptKiddie_HTB.md",
        "retired": true,
        "date": "15-05-2021",
        "tags": ["Web", "File Upload"]
    },
    {
        "title": "Time Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Web Server vulnerable to CVE-2019-12384",
        "url": "/blogs/time-walkthrough-htb",
        "filename": "Time_HTB.md",
        "retired": true,
        "date": "30-01-2021",
        "tags": ["Web", "CVE"]
    },
    {
        "title": "Delivery Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Server running a vulnerable Ticketing System and containing leaked credentials.",
        "url": "/blogs/delivery-walkthrough-htb",
        "filename": "Delivery_HTB.md",
        "retired": true,
        "date": "28-01-2021",
        "tags": ["Bash", "Account Misconfiguration"]
    },
    {
        "title": "Luanne Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A NetBSD machine vulnerable to parameter injection and file misconfigurations.",
        "url": "/blogs/luanne-walkthrough-htb",
        "filename": "Luanne_HTB.md",
        "retired": true,
        "date": "26-01-2021",
        "tags": ["Web", "Injection", "File Misconfigurations"]
    },
    {
        "title": "Laboratory Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Server running GitLab vulnerable to LFI and PATH Hijacking for Privilege Escalation.",
        "url": "/blogs/laboratory-walkthrough-htb",
        "filename": "Laboratory_HTB.md",
        "retired": true,
        "date": "25-01-2021",
        "tags": ["LFI", "Path Hijacking"]
    },
    {
        "title": "Academy Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Web Server vulnerable to Authentication Bypass via Request Manipulation and CVE-2018-15133",
        "url": "/blogs/academy-walkthrough-htb",
        "filename": "Academy_HTB.md",
        "retired": true,
        "date": "20-01-2021",
        "tags": ["Auth Bypass", "CVE"]
    },
    {
        "title": "Doctor Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Web server vulnerable to SSTI and contains misconfigured Splunk.",
        "url": "/blogs/doctor-walkthrough-htb",
        "filename": "Doctor_HTB.md",
        "retired": true,
        "date": "18-01-2021",
        "tags": ["Web", "SSTI", "Splunk"]
    },
    {
        "title": "OpenAdmin Walkthrough | HackTheBox",
        "banner": HackTheBox,
        "summary": "A Linux Web server running vulnerable version of OpenNetAdmin and requires " +
            "Local Port Forwarding for horizontal privilege escalation.",
        "url": "/blogs/openAdmin-walkthrough-htb",
        "filename": "OpenAdmin_HTB.md",
        "retired": true,
        "date": "09-05-2020",
        "tags": ["Web", "Exploit-DB", "PHP"]
    },
];

export default blog_data;